export const transformModalState = {};
